import React from "react";
import css from './homeAdv.module.scss'
import {observer} from "mobx-react";
import classNames from "classnames";

const Index = ({className, adv}) => {
    const {id,file,title,subTitle,link} = adv
    const onClick = ()=>{
        window.open(link,"_blank")
    }
    return (
        <div className={classNames(className, css.root)} onClick={onClick}>
            <img src={file} alt="" className={css.img}/>
        </div>
    )
}

export default observer(Index)